module.exports = __webpack_public_path__ + "static/media/FotosCentro10.74fc29a9.jpg";